<template>
 <div class="show">
  <div v-if="showSearch" style="width: 100%;height: 100%;position: fixed;z-index: 10000"  @click="clearSearch"></div>
  <div class="group-search" v-if="showSearch">
   <div class="group-search-form">
    <i-form style="margin: 2% 2%">
     <i-input placeholder="请输入分组名称" style="width: 60%" v-model="searchGroup" @on-enter="toSearchGroup"></i-input>
     <i-button type="primary" size="small" style="margin-left:2%" @click="toSearchGroup">查询</i-button>
     <i-button type="error" size="small" style="margin-left:2%" @click="hideSearchGroup">取消</i-button>
    </i-form>
    <TreeTable style="height:80%;margin: 0 2%;width: 76%"
               :show-header="showHeader"
               :selectable="selectTable"
               :data="directlyUnderBindData"
               :columns="groupColumns"
               :is-fold="isFold"
               :expand-type="expandType"
               @cell-click="treeClick"></TreeTable>
   </div>
  </div>
  <div class="show-form">
   <i-form class="search-form" label-position="left" :label-width="80">
    <Form-item label="切换分组:">
     <!--        <i-select placeholder="请选择" v-model="model1" @on-change="onLoadVehicleInfosByGroupId" filterable>-->
     <!--         <Option v-for="item in directlyUnderBindData" :value="item.id" :key="item.id">{{item.name}}</Option>-->
     <!--        </i-select>-->
     <i-input style="width: 60%" placeholder="请选择分组名称" v-model="model1" @on-focus="toShowSearch"></i-input>
    </Form-item>
    <Form-item label="车牌搜索:">
     <i-input placeholder="请输入车牌号" style="width: 60%" v-model="inputNum" @on-enter="filterChange"></i-input>
     <i-button type="primary" size="small" style="margin-left:2%" @click="filterChange">搜索</i-button>
    </Form-item>
    <i-table :columns="columns" :data="trackData" height="300"  style="margin-top: 5px;" size="small" :loading="loading" @on-row-click="onTableClick"></i-table>
   </i-form>
  </div>
 </div>
</template>

<script>
import store from '@/store'
import axios from '../../libs/api.request'
export default {
  name: 'track-search',
  data () {
    return {
      searchGroup: '',
      // tree-table设置
      selectTable: false,
      showHeader: false,
      showSearch: false,
      isFold: true,
      expandType: false,
      groupColumns: [
        {
          title: 'name',
          key: 'name'
        }
      ],
      // 车辆table
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: '70'
        },
        {
          title: '车牌号',
          key: 'registrationNum',
          width: '110'
        },
        // {
        //  title: '主机号码',
        //  key: 'terminalNum',
        //  width: '200',
        //  render:function (h,params) {
        //
        //    console.log(params.row.terminalNum)
        //    let list =[]
        //   if (params.row.terminalNum!=null){
        //
        //     var aaa=''
        //   for (let i = 0; i < params.row.terminalNum.length; i++) {
        //    // console.log(params.row.terminalNum[i])
        //
        //     list.push(params.row.terminalNum[i].terminalNum);
        //      aaa += params.row.terminalNum[i].terminalNum+"\n"
        //   }
        //    console.log(list)
        //    console.log(aaa)
        //   }
        //   return(
        //    [aaa]
        //    // <div>
        //   // {"内容a前面部分<br />内容a后面部分"} //换行失败
        //   // "内容a前面部分<br />内容a后面部分" //换行成功
        //   //  </div>
        //   )
        //  }
        // },
        // {
        //  title: '主机类型',
        //  key: 'terminalNum',
        //  width: '110',
        //  render:function (h,params) {
        //
        //   console.log(params.row.terminalNum)
        //   let list =[]
        //   if (params.row.terminalNum!=null){
        //
        //   for (let i = 0; i < params.row.terminalNum.length; i++) {
        //
        //    list.push(params.row.terminalNum[i].positioningDeviceModel==1?'BSJ_A6BD':params.row.terminalNum[i].positioningDeviceModel==2?'BSJ_GF03':params.row.terminalNum[i].positioningDeviceModel==3?'BSJ_M11'
        //      :params.row.terminalNum[i].positioningDeviceModel==4?'K5':params.row.terminalNum[i].positioningDeviceModel==5?'D5X':'G_3G');
        //
        //   }
        //   }
        //   return h('div',list)
        //  }
        // },
        {
          title: '车辆分组',
          key: 'vehicleInfoGroup',
          ellipsis: 'true',
          width: '200'
        },
        {
          title: '车辆类型',
          key: 'vehicleType',
          ellipsis: 'true',
          minWidth: 100
        }
      ],
      // 输入车牌号
      inputNum: '',
      // 车辆数据
      trackData: [],
      trackSearchData: [],
      // table loading
      loading: false,
      // 选择器model
      model1: null,
      // 车队分组数据
      directlyUnderBindData: [],
      groupSearchData: []
    }
  },
  methods: {
    // 影藏搜索框
    hideSearchBar () {
    },
    // 隐藏分组搜索
    hideSearchGroup () {
      this.showSearch = false
    },
    treeClick (row) {
      this.model1 = row.name
      this.onLoadVehicleInfosByGroupId(row.id)
      this.searchGroup = ''
      this.showSearch = false
    },
    clearSearch () {
      this.showSearch = false
    },
    toShowSearch () {
      if (this.groupSearchData.length !== 0) {
        this.directlyUnderBindData = this.groupSearchData
      }
      this.showSearch = true
    },
    onTableClick (row) {
      console.log(row)
      this.$emit('getTrackNum', row.registrationNum, row.terminalNum, row.positioningDeviceInfos)
    },

    // 查询分组信息
    toSearchGroup () {
      this.groupSearchData = this.directlyUnderBindData
      this.directlyUnderBindData = []
      let reg = new RegExp(this.searchGroup)
      this.groupSearchData.forEach(item => {
        if (reg.test(item.name)) {
          this.directlyUnderBindData.push(item)
        }
        if (item.children.length !== 0) {
          console.log(item.children)
          item.children.forEach(itemChild => {
            if (reg.test(itemChild.name)) {
              this.directlyUnderBindData.push(itemChild)
            }
          })
        }
      })
    },
    // 查询车辆
    filterChange () {
      this.trackData = []
      let reg = new RegExp(this.inputNum)
      if (this.model1) {
        this.trackSearchData.forEach(item => {
          if (reg.test(item.id) || reg.test(item.registrationNum) || reg.test(item.vehicleType)) {
            this.trackData.push(item)
          }
        })
      } else {
        let trackData = []
        let trackSearchDate = []
        axios.request({
          url: '/crm/vehicleinfo/clientsearch?keyword=' + this.inputNum,
          method: 'GET',
          credentials: 'include',
          data: this.inputNum
        }).then(res => {
          res.data.data.forEach(vehicleinfo => {
            let obj = {
              id: vehicleinfo.id,
              registrationNum: vehicleinfo.registrationNum,
              terminalNum: vehicleinfo.positioningDeviceInfos,
              vehicleInfoGroup: vehicleinfo.vehicleInfoGroup.name,
              vehicleType: vehicleinfo.vehicleType.name
            }
            if (vehicleinfo.vehicleType) {
              trackData.push(obj)
              trackSearchDate.push(obj)
            } else {
              delete obj.vehicleType
              trackData.push(obj)
              trackSearchDate.push(obj)
            }
          })
          this.trackData = trackData
          this.trackSearchData = trackSearchDate
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 获取车队中所有车辆信息
    onLoadVehicleInfosByGroupId (id) {
      this.loading = true
      console.log(id)
      store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
        params: { groupId: id },
        urlparams: null
      }).then(() => {
        let trackData = []
        let trackSearchDate = []
        store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicleinfo => {
          if (vehicleinfo.vehicleType) {
            trackData.push({
              id: vehicleinfo.id,
              registrationNum: vehicleinfo.registrationNum,
              terminalNum: vehicleinfo.positioningDeviceInfos,
              vehicleInfoGroup: vehicleinfo.vehicleInfoGroup.name,
              vehicleType: vehicleinfo.vehicleType.name,
              positioningDeviceInfos: vehicleinfo.positioningDeviceInfos
            })
            trackSearchDate.push({
              id: vehicleinfo.id,
              registrationNum: vehicleinfo.registrationNum,
              terminalNum: vehicleinfo.positioningDeviceInfos,
              vehicleInfoGroup: vehicleinfo.vehicleInfoGroup.name,
              vehicleType: vehicleinfo.vehicleType.name,
              positioningDeviceInfos: vehicleinfo.positioningDeviceInfos

            })
          } else {
            trackData.push({
              id: vehicleinfo.id,
              registrationNum: vehicleinfo.registrationNum,
              terminalNum: vehicleinfo.positioningDeviceInfos,
              vehicleInfoGroup: vehicleinfo.vehicleInfoGroup.name,
              positioningDeviceInfos: vehicleinfo.positioningDeviceInfos

            })
            trackSearchDate.push({
              id: vehicleinfo.id,
              registrationNum: vehicleinfo.registrationNum,
              terminalNum: vehicleinfo.positioningDeviceInfos,
              vehicleInfoGroup: vehicleinfo.vehicleInfoGroup.name,
              positioningDeviceInfos: vehicleinfo.positioningDeviceInfos
            })
          }
        })
        // 车辆列表
        this.trackData = trackData
        this.trackSearchData = trackSearchDate
        // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetGroupRecursiveAllResult)
        // this.vehicleListData = this.makeSelectTableDataItem(store.getters.get_VehicleInfo_GetGroupRecursiveAllResult)
        this.loading = false
      }).catch(err => {
        this.$Message.error(err)
        this.loading = false
      })
    }
  },
  mounted () {
    this.directlyUnderBindData = []
    store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
      params: null,
      urlparams: null
    }).then(() => {
      if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
        store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehicleInfoGroupItem => {
          let children = []
          store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
            params: { id: vehicleInfoGroupItem.id },
            urlparams: null
          }).then(res => {
            if (res.data.length === 0) {
            } else {
              res.data.forEach(value => {
                children.push({
                  name: value.name,
                  id: value.id
                })
              })
            }
          })
          if (children) {
            this.directlyUnderBindData.push(
              {
                id: vehicleInfoGroupItem.id,
                name: vehicleInfoGroupItem.name,
                children: children
              }
            )
          } else {
            this.directlyUnderBindData.push(
              {
                id: vehicleInfoGroupItem.id,
                name: vehicleInfoGroupItem.name
              }
            )
          }
        })
      }
      this.model1 = this.directlyUnderBindData[0].name
      this.onLoadVehicleInfosByGroupId(this.directlyUnderBindData[0].id)
    }).catch(err => {
      this.$Message.error(err)
    })
    console.log(store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult)
  }
}
</script>

<style scoped>
 .show{
  max-width:488.03px;
  height: 380px;
  background: #fff;
  float: left;
  position: absolute;
  z-index: 9999;
  border: 1px #ccc solid;
 }
 .group-search{
  width:100%;
  height: 100%;
  /*background: rgba(0, 0 , 0 , 0.1);*/
  position: absolute;
  z-index: 11000;
 }
 .group-search-form{
  width:90%;
  height:80%;
  background:#fff;
  position: absolute;
  z-index: 12000;
  margin: 5% 10%;
  border: 1px #ccc solid;
 }
 .show .show-form{
  width: 98%;
  height: 100%;
  margin: 0 auto;
 }
 .show>>>.ivu-input{
  height: 24px;
 }
 /*.show>>>.ivu-form-item-content {*/
 /* margin-left: 0!important;*/
 /*}*/
 .show>>>.ivu-select-single .ivu-select-selection{
  height: 24px;
 }
 .show>>>.ivu-form-item{
  margin-bottom: 2px;
 }
 .show>>>.ivu-select-single .ivu-select-selection .ivu-select-placeholder{
  height: 24px!important;
  line-height: 24px!important;
 }
 .show>>>.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
  height: 24px!important;
  line-height: 24px!important;
 }
 .show>>>.ivu-select-input{
  height: 24px;
  line-height: 24px;
 }
</style>
